import { render } from "./PPAPApplicabilityEvaluationDetail.vue?vue&type=template&id=11bf0bda&scoped=true"
import script from "./PPAPApplicabilityEvaluationDetail.vue?vue&type=script&lang=js"
export * from "./PPAPApplicabilityEvaluationDetail.vue?vue&type=script&lang=js"

import "./PPAPApplicabilityEvaluationDetail.vue?vue&type=style&index=0&id=11bf0bda&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bf0bda"]])

export default __exports__